export const isSite = (site) => window.settings.internalName.includes(site)